// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__7Fmu5","header":"PatientQuestionnaire_header__1eeyu","info":"PatientQuestionnaire_info__6w2bj"};